import game.*
import game.entity.Entity

class Item : Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("yellow-sparkle")
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        var dialog = ""

        with(game.player) {
            when (params) {
                "lens" -> {
                    lens = true
                    dialog = "Dialog_Lens"
                }
                "map" -> {
                    map = true
                    dialog = "Dialog_Map"
                }
                "shard-scanner" -> {
                    shardScanner = true
                    dialog = "Dialog_ShardScanner"
                }
                "item-scanner" -> {
                    itemScanner = true
                    dialog = "Dialog_ItemScanner"
                }
                "lore-scanner" -> {
                    loreScanner = true
                    dialog = "Dialog_LoreScanner"
                }
                "light-1" -> {
                    lightSource = LightSource.Candle
                    dialog = "Dialog_Light1"
                }
                "light-2" -> {
                    if (lightSource == LightSource.Candle) {
                        lightSource = LightSource.Torch
                        dialog = "Dialog_Light2"
                    } else {
                        dialog = "Dialog_Light2Alternate"
                    }
                }
                "light-3" -> {
                    lightSource = LightSource.Lantern
                    dialog = "Dialog_Light3"
                }
                "bracer-1" -> {
                    bracer = Bracer.Cloth
                    dialog = "Dialog_Bracer1"
                }
                "bracer-2" -> {
                    bracer = Bracer.Dragon
                    dialog = "Dialog_Bracer2"
                }
                "speedup-1" -> {
                    if (speed == SpeedUp.None) {
                        speed = SpeedUp.BlueFeather
                        dialog = "Dialog_SpeedUp1"
                    } else {
                        dialog = "Dialog_SpeedUp1Alternate"
                    }
                }
                "speedup-2" -> {
                    speed = SpeedUp.RedFeather
                    dialog = "Dialog_SpeedUp2"
                }
                "jump-1" -> {
                    jump = Jump.Spring
                    dialog = "Dialog_Jump1"
                }
                "jump-2" -> {
                    jump = Jump.Cape
                    dialog = "Dialog_Jump2"
                }
                "weapon-1" -> {
                    weapon = Weapon.Stick
                    dialog = "Dialog_Weapon1"
                }
                "weapon-2" -> {
                    if (weapon == Weapon.Stick) {
                        weapon = Weapon.Sword
                        dialog = "Dialog_Weapon2"
                    }
                }
                "weapon-3" -> {
                    weapon = Weapon.RoyalSword
                    dialog = "Dialog_Weapon3"
                }
                "flippers" -> {
                    flippers = true
                    dialog = "Dialog_Flippers"
                }
                "boots-1" -> {
                    lavaBoots = true
                    dialog = "Dialog_Boots1"
                }
                "boots-2" -> {
                    divineBoots = true
                    dialog = "Dialog_Boots2"
                }
                "armor-1" -> {
                    if (armor == Armor.Holy) {
                        dialog = "Dialog_Armor1Alternate"
                    } else {
                        armor = Armor.Light
                        dialog = "Dialog_Armor1"
                    }
                }
                "armor-2" -> {
                    armor = Armor.Holy
                    dialog = "Dialog_Armor2"
                }
                else -> throw Exception("Unknown item type: $params")
            }
        }

        game.playSound("item")

        game.showDialog(dialog)

        room.removePermanently(game, this)

        return false
    }
}